<app-lista-categoria
  titulo="Excesos de velocidad"
  color="#ef5350"
  [items]="items"
  [umbral]="umbral"
  [cargando]="cargando"
  textoVacio="Sin excesos detectados"
  (verEnMapa)="verEnMapa($event)"
></app-lista-categoria>
